import { render, staticRenderFns } from "./ManageLookupLists.vue?vue&type=template&id=2d4d4556&scoped=true"
import script from "./ManageLookupLists.vue?vue&type=script&lang=js"
export * from "./ManageLookupLists.vue?vue&type=script&lang=js"
import style0 from "./ManageLookupLists.vue?vue&type=style&index=0&id=2d4d4556&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4d4556",
  null
  
)

export default component.exports